export type ForfeoReserveEdgeErrorLike = {
  message?: string;
  context?: unknown;
};

type EdgePayload = {
  error?: unknown;
};

async function responseErrorCode(context: unknown) {
  if (!(context instanceof Response)) return '';

  try {
    const payload = await context.clone().json() as EdgePayload;
    return typeof payload?.error === 'string'
      ? payload.error.trim()
      : '';
  } catch {
    return '';
  }
}

export async function resolveForfeoReserveEdgeErrorCode(
  data: unknown,
  error: ForfeoReserveEdgeErrorLike | null,
  fallback: string,
) {
  const payloadError = (
    data
    && typeof data === 'object'
    && 'error' in data
    && typeof (data as EdgePayload).error === 'string'
  )
    ? String((data as EdgePayload).error).trim()
    : '';

  if (payloadError) return payloadError;

  const responseCode = await responseErrorCode(error?.context);
  if (responseCode) return responseCode;

  if (error?.context instanceof Response && error.context.status === 404) {
    return 'edge_function_not_deployed';
  }

  const message = String(error?.message || '').trim();

  if (message.toLowerCase().includes('non-2xx')) {
    return fallback;
  }

  return message || fallback;
}

export function humanizeForfeoReserveError(value: unknown): string {
  const code = value instanceof Error
    ? value.message
    : String(value || '');

  const messages: { [key: string]: string } = {
    edge_function_not_deployed:
      'Le service Reserve requis n’est pas encore déployé.',
    authentication_required:
      'Votre session est requise pour utiliser Forfeo Reserve.',
    authentication_invalid:
      'Votre session Reserve n’est plus valide. Reconnectez-vous.',
    unsafe_api_key_rejected:
      'La configuration de sécurité Reserve a refusé cette requête.',
    backend_not_configured:
      'Le service Reserve n’est pas complètement configuré.',
    server_not_configured:
      'Le service Reserve n’est pas complètement configuré.',
    origin_forbidden:
      'Le domaine Forfeo Explore n’est pas autorisé par ce service Reserve.',
    policy_network_error:
      'Les politiques Reserve sont temporairement injoignables. Réessayez dans un instant.',
    invalid_session:
      'Votre session Reserve n’est plus valide. Reconnectez-vous puis réessayez.',
    calendar_network_error:
      'Le calendrier Reserve est temporairement indisponible.',
    portal_network_error:
      'Le portail Reserve est temporairement indisponible.',
    reserve_production_request_failed:
      'Le centre d’intégration Reserve est temporairement indisponible.',
  };

  return messages[code] || code;
}
